import { profile } from '@content/portfolioData'

export function Hero() {
  return (
    <section className="modern-hero" id="hero">
      <div className="modern-hero__inner">
        <div className="modern-hero__content">
          <span className="modern-hero__label">{profile.company}</span>
          <h1 className="modern-hero__name">{profile.name}</h1>
          <p className="modern-hero__tagline">
            {profile.title} &mdash; {profile.bio}
          </p>
          <div className="modern-hero__cta">
            <a href="#projects" className="modern-btn modern-btn--primary">
              View Projects
            </a>
            <a href="#contact" className="modern-btn modern-btn--secondary">
              Get in Touch
            </a>
          </div>
        </div>
        <a href="https://youtu.be/9phRRAG5vbM?si=Wtx_ZPNOuTn9BSLf" target="_blank" rel="noopener noreferrer">
          <img
            src={profile.portrait}
            alt={profile.name}
            className="modern-hero__portrait"
            loading="eager"
          />
        </a>
      </div>
    </section>
  )
}
